import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, Crown, CheckCircle, Zap, Shield, Clock, CreditCard } from 'lucide-react';
import { Button } from './ui/button';

export default function SubscriptionExpired({ user, onLogout }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleUpgrade = () => {
    setLoading(true);
    navigate('/payment');
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (onLogout) onLogout();
    navigate('/login');
  };

  const trialEndDate = user?.trial_end 
    ? new Date(user.trial_end).toLocaleDateString('pt-BR')
    : 'N/A';

  return (
    <div className="min-h-screen bg-gradient-to-br from-zinc-950 via-zinc-900 to-zinc-950 flex items-center justify-center p-4">
      <div className="max-w-lg w-full">
        {/* Alert Card */}
        <div className="bg-zinc-900/80 backdrop-blur-sm border border-red-500/30 rounded-2xl p-8 shadow-2xl">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-full bg-red-500/10 flex items-center justify-center">
              <AlertTriangle className="w-10 h-10 text-red-500" />
            </div>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-white text-center mb-2">
            Período de Teste Expirado
          </h1>
          
          <p className="text-zinc-400 text-center mb-6">
            Seu período de teste gratuito de 7 dias terminou em <span className="text-red-400 font-semibold">{trialEndDate}</span>.
            Para continuar usando o MeuGestor, assine um de nossos planos.
          </p>

          {/* Features reminder */}
          <div className="bg-zinc-800/50 rounded-xl p-4 mb-6">
            <p className="text-sm text-zinc-300 font-medium mb-3 flex items-center gap-2">
              <Crown className="w-4 h-4 text-yellow-500" />
              Com o plano Premium você tem acesso a:
            </p>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-zinc-400">
                <CheckCircle className="w-4 h-4 text-green-500" />
                Clientes ilimitados
              </li>
              <li className="flex items-center gap-2 text-sm text-zinc-400">
                <Zap className="w-4 h-4 text-yellow-500" />
                Mensagens automáticas via WhatsApp
              </li>
              <li className="flex items-center gap-2 text-sm text-zinc-400">
                <Shield className="w-4 h-4 text-blue-500" />
                Cobranças via PIX com QR Code
              </li>
              <li className="flex items-center gap-2 text-sm text-zinc-400">
                <Clock className="w-4 h-4 text-purple-500" />
                Agendamento de mensagens
              </li>
            </ul>
          </div>

          {/* Price */}
          <div className="text-center mb-6">
            <p className="text-zinc-400 text-sm">Apenas</p>
            <p className="text-3xl font-bold text-white">R$ 19,90<span className="text-lg text-zinc-400">/mês</span></p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <Button 
              onClick={handleUpgrade}
              disabled={loading}
              className="w-full bg-gradient-to-r from-violet-600 to-purple-600 hover:from-violet-700 hover:to-purple-700 text-white py-6 text-lg font-semibold"
              data-testid="btn-subscribe-now"
            >
              <CreditCard className="w-5 h-5 mr-2" />
              {loading ? 'Carregando...' : 'Pagar com PIX'}
            </Button>
            
            <Button 
              onClick={handleLogout}
              variant="outline"
              className="w-full border-zinc-700 text-zinc-400 hover:text-white hover:border-zinc-600"
              data-testid="btn-logout-expired"
            >
              Sair da Conta
            </Button>
          </div>

          {/* Help text */}
          <p className="text-xs text-zinc-500 text-center mt-6">
            Dúvidas? Entre em contato com nosso suporte pelo WhatsApp.
          </p>
        </div>
      </div>
    </div>
  );
}
